<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta content="width=device-width, initial-scale=1.0" name="viewport" />
  <meta name="env-placeholder" />
  <title>Gecko Cantilever</title>
</head>
<body>
<div id="root"></div>
<script src="/src/App.tsx" type="module"></script>
</body>
</html>
